// @flow
import React from "react";
// $FlowFixMe
import css from "./social-icons.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faTwitter, faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import openExternalLink from "./../../lib/externallink";

class SocialIcons extends React.Component<*> {
  render(): Object {
    return (
      <div className={css.socialicons}>
        {process.env.REACT_APP_FACEBOOK_URL ? (
          <a href={process.env.REACT_APP_FACEBOOK_URL}>
            <FontAwesomeIcon icon={faFacebookF} />
          </a>
        ) : null}
        {process.env.REACT_APP_TWITTER_URL ? (
          <a href={process.env.REACT_APP_TWITTER_URL}>
            <FontAwesomeIcon icon={faTwitter} />
          </a>
        ) : null}
        {process.env.REACT_APP_INSTA_URL ? (
          <a href={process.env.REACT_APP_INSTA_URL}>
            <FontAwesomeIcon icon={faInstagram} />
          </a>
        ) : null}
        <a
          href="https://idrad.io"
          onClick={(r) => {
            r.preventDefault();
            openExternalLink("https://indemandradio.com");
          }}
        >
          <FontAwesomeIcon icon={faHome} />
        </a>

        {/* <a href={this.props.streamURL}><FontAwesomeIcon icon={faItunesNote}/></a> */}
      </div>
    );
  }
}
export default SocialIcons;
